const NS = 'WoolLabShareSwatchModalBlock';
const CLS = 'woolLabShareSwatchModalBlock';

export class WoolLabShareSwatchModalBlock {
	constructor(el, data) {
		this.$el = $(el);
		this.shareSwatchesApi = data.shareSwatchesApi;
		this.selectedSwatchIds = data.selectedSwatchIds;

		this.shareEmail = '';

		this.$btnDone = this.$el.find(`.${CLS}-doneBtn`);
		this.$sendBtn = this.$el.find(`.${CLS}-sendBtn`);
		this.$emailInput = this.$el.find(`.${CLS}-shareSwatch-textInput`);


		this.$sendBtn.on('click', () => {
			if (this.newMoodboardText !== '') {
				this.postShareSwatchesApi();
			}
		});


		this.$emailInput.on('keyup', (event) => {
			let input = $(event.currentTarget).val().trim();
			if (input.length > 0) {
				this.$sendBtn.removeClass('disabled');
			} else {
				this.$sendBtn.addClass('disabled');
			}

			this.shareEmail = input;
		});
	}


	postShareSwatchesApi() {
		let url = `${this.shareSwatchesApi}?swatches=${encodeURIComponent(this.selectedSwatchIds)}?shareEmail=${encodeURIComponent(this.shareEmail)}`;

		fetch(url, {
			method: 'POST',
		}).then((response) => {
			return response.json();
		}).then((_json) => {
		}).catch((_error) => {
		});
	}
}

